module.exports = __webpack_public_path__ + "img/cta-chrome.ebe555c5.svg";